import React from 'react';
import { useNavigate } from 'react-router';

import { StepProps } from '@/widgets/ServiceFormTemplate';

import { InvoiceStatus } from '@/shared/types';
import { StepControlPanel } from '@/shared/ui';

import { Result } from '@/components/Forms/Steps/Result';

import { ROUTES } from '@/router/config';

export interface WeaponPurchasePermitResultProps {
  invoiceStatus: InvoiceStatus;
}

export const WeaponPurchasePermitResult: React.FC<StepProps<WeaponPurchasePermitResultProps>> = ({
  serviceCode,
  invoiceStatus,
}) => {
  const navigate = useNavigate();

  return (
    <>
      <Result variant="new" serviceCode={serviceCode} invoiceStatus={invoiceStatus} />

      <StepControlPanel
        next={() => navigate(ROUTES.USER.REQUESTS.ACTIVE_REQUESTS)}
        nextBtnText="Мої запити"
        withArrow={false}
      />
    </>
  );
};
